<template>
  <ui-modal
    ref="modal"
    id="asignarTarifasTerrestres"
    title="Asignar tarifas de transporte"
    @close="$emit('close')"
  >
    <div class="d-flex w-100 flex-column p-3">

      <!-- Selección de planta -->
      <div class="d-flex">
        <ui-select
          class="w-100"
          has-search
          label="Planta/Bodega (*)"
          placeholder="Seleccionar planta"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="plants"
          v-model="plantaModel"
          @change="onPlantaChange"
        />
      </div>

      <!-- Tarifas de transporte del cliente para la planta seleccionada -->
      <div class="mt-3" v-if="plantaModel.id">

        <Loading v-if="loading" />

        <div v-else-if="tarifas.length === 0" class="text-muted text-center py-4">
          El cliente no tiene tarifas de transporte para esta planta.
        </div>

        <table v-else class="table table-sm table-hover">
          <thead>
            <tr>
              <th style="width: 40px">
                <input type="checkbox" :checked="allSelected" @change="toggleAll" />
              </th>
              <th>Proveedor</th>
              <th>Moneda</th>
              <th class="text-right">Costo</th>
              <th class="text-right">Venta</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="t in tarifas" :key="t.id">
              <td>
                <input type="checkbox" :value="t.id" v-model="selectedIds" />
              </td>
              <td v-text="t.proveedor"></td>
              <td v-text="t.moneda"></td>
              <td class="text-right" v-text="formato(t.costo)"></td>
              <td class="text-right" v-text="formato(t.venta)"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Botones -->
      <div class="d-flex justify-content-between pt-3">
        <Button
          :size="23"
          color="#dc3545"
          colorText="#ffffff"
          :width="120"
          :height="35"
          text="Cerrar"
          @click.native="$emit('close')"
        />

        <Button
          :size="23"
          color="#2da44e"
          colorText="#ffffff"
          :width="120"
          :height="35"
          text="Agregar"
          @click.native="asignar"
          :inactive="isSending || selectedIds.length === 0"
        />
      </div>
    </div>
  </ui-modal>
</template>

<script>
import UiModal from "keen-ui/src/UiModal";
import UiSelect from "keen-ui/src/UiSelect";
import Button from "../../../common/Button.vue";
import Loading from "../../../common/loading.vue";
import { getGroundTariffsForAssign, assignGroundTariffs } from "../../../../constants/lineas";

export default {
  components: { UiModal, UiSelect, Button, Loading },

  props: {
    show: { type: Boolean, default: false },
    booking_number: { type: [String, Number], default: null },
    plants: { type: Array, default: () => [] },
    // Contexto Instructivo de Embarque: si viene, las tarifas se asocian al instructivo.
    boarding_instruction_id: { type: [Number, String], default: null },
  },

  data() {
    return {
      plantaModel: {},
      tarifas: [],
      selectedIds: [],
      loading: false,
      isSending: false,
    };
  },

  computed: {
    allSelected() {
      return this.tarifas.length > 0 && this.selectedIds.length === this.tarifas.length;
    },
  },

  methods: {
    formato(n) {
      return (parseFloat(n) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    limpiar() {
      this.plantaModel = {};
      this.tarifas = [];
      this.selectedIds = [];
      this.loading = false;
      this.isSending = false;
    },

    toggleAll(e) {
      this.selectedIds = e.target.checked ? this.tarifas.map((t) => t.id) : [];
    },

    async onPlantaChange() {
      this.tarifas = [];
      this.selectedIds = [];

      if (!this.plantaModel.id) return;

      this.loading = true;

      const res = await getGroundTariffsForAssign({
        booking_number: this.booking_number,
        plant_id: this.plantaModel.id,
        boarding_instruction_id: this.boarding_instruction_id,
        is_boarding_instruction: !!this.boarding_instruction_id,
      });

      this.tarifas = res && res.status === 200 ? res.data : [];
      this.loading = false;
    },

    async asignar() {
      if (this.selectedIds.length === 0) {
        return this.$vToastify.warning("Seleccione al menos una tarifa", "¡Precaución!");
      }

      this.isSending = true;
      this.$vToastify.loader("Asignando tarifas de transporte...");

      const res = await assignGroundTariffs({
        booking_number: this.booking_number,
        plant_id: this.plantaModel.id,
        tariff_ids: this.selectedIds,
        boarding_instruction_id: this.boarding_instruction_id,
        is_boarding_instruction: !!this.boarding_instruction_id,
      });

      this.$vToastify.stopLoader();

      if (res && res.status === 200) {
        this.$vToastify.success(res.message, "¡Éxito!");
        this.$emit("assigned");
      } else {
        this.$vToastify.warning((res && res.message) || "No se pudieron asignar las tarifas", "¡Precaución!");
      }

      this.isSending = false;
    },
  },

  watch: {
    show(value) {
      if (value) {
        this.limpiar();
        this.$refs.modal.open();
      } else {
        this.$refs.modal.close();
      }
    },
  },
};
</script>

<style>
#asignarTarifasTerrestres > .ui-modal__wrapper > .ui-modal__container {
  width: 55% !important;
}
</style>
